export default function ReadMediaName(paperName: string) {
  const config = useRuntimeConfig()
  const nuxtApp = useNuxtApp()

  return (
    nuxtApp.$t('ReadMedia', { name: config.public.site.name }) +
    (!isMm() ? ` ${paperName}` : '')
  )
}
